import Vue from 'vue'
import App from './App'
import router from './router'
import storeOption from '@/store'
import Vuex from 'vuex'
import { sync } from 'vuex-router-sync'
import axios from '@/apis/axios'
import wx from 'weixin-js-sdk'
import { Popup,Picker,Toast,InfiniteScroll } from 'mint-ui'
import { DatePicker } from 'element-ui'
import 'mint-ui/lib/style.css';

// 引入需要的组件
Vue.component(Popup.name, Popup);
Vue.component(Picker.name, Picker);
Vue.component(DatePicker.name, DatePicker);
Vue.use(Vuex)
Vue.use(InfiniteScroll);

const store = new Vuex.Store(storeOption)

// 挂在store和axios到vue对象
Vue.prototype.axios = axios
Vue.prototype.wx = wx
Vue.prototype.store = store
Vue.prototype.$toast = Toast;

sync(store, router)

Vue.config.productionTip = false

import wechatApi from '@/common/wechatApi'
Vue.prototype.wechatApi = wechatApi

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js